module.exports = __webpack_public_path__ + "img/frame (267).e8f0e99a.jpg";